import { render, staticRenderFns } from "./ClinicCategories.vue?vue&type=template&id=222b6b94"
import script from "./ClinicCategories.vue?vue&type=script&lang=js"
export * from "./ClinicCategories.vue?vue&type=script&lang=js"
import style0 from "./ClinicCategories.vue?vue&type=style&index=0&id=222b6b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports